import { create } from 'zustand';

const useDashboardStore = create((set, get) => ({
  visitKpi: null,
  rxKpi: null,
  patientData: null,
  couponKpi: null,
  pointKpi: null,
  isLoading: false,

  setVisitKpi: (data) => {
    if (JSON.stringify(data) === JSON.stringify(get().visitKpi)) return;
    set({ visitKpi: data });
  },
  setRxKpi: (data) => {
    if (JSON.stringify(data) === JSON.stringify(get().rxKpi)) return;
    set({ rxKpi: data });
  },
  setPatientData: (data) => {
    if (JSON.stringify(data) === JSON.stringify(get().patientData)) return;
    set({ patientData: data });
  },
  setCouponKpi: (data) => {
    if (JSON.stringify(data) === JSON.stringify(get().couponKpi)) return;
    set({ couponKpi: data });
  },
  setPointKpi: (data) => {
    if (JSON.stringify(data) === JSON.stringify(get().pointKpi)) return;
    set({ pointKpi: data });
  },
  setLoading: (isLoading) => set({ isLoading }),
}));

export default useDashboardStore;
